import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardWebhooksDetailsDocument,
  type DashboardWebhooksDetailsQuery,
  type DashboardWebhooksDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_WEBHOOKS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardWebhooksDetailsQuery,
    DashboardWebhooksDetailsQueryVariables
  >({
    query: DashboardWebhooksDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
    fetchPolicy: "network-only",
  });

  return data;
};
